import React, { Suspense, useEffect } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

import { Loading, Sidebar } from '../components'
import { routes } from 'utils'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'

const PrivateLayout = () => {
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'F1') {
        e.preventDefault()
        if (location.pathname === routes.sales) {
          const input = (document.getElementById('posProductSearchInput') ||
            document.querySelector('.search-input input[name="q"]') ||
            document.querySelector('input[name="q"]')) as HTMLInputElement | null
          if (input) {
            input.focus()
            input.select()
          }
        } else {
          navigate(routes.sales, {
            state: { focusProductSearch: true, timestamp: Date.now() },
          })
        }
      }
    }
    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [location.pathname, navigate])

  return (
    <div className="app-layout d-flex flex-column flex-md-row min-vh-100 w-100 overflow-hidden" style={{ height: '100vh' }}>
      {/* Mobile Top Header for non-sales pages */}
      {location.pathname !== routes.sales && (
        <div className="d-flex d-md-none align-items-center justify-content-between px-3 py-2 bg-white border-bottom flex-shrink-0" style={{ zIndex: 1020, minHeight: '48px' }}>
          <button
            type="button"
            className="btn btn-link p-0 text-dark border-0 d-flex align-items-center"
            onClick={() => window.dispatchEvent(new CustomEvent('toggle-sidebar'))}
            aria-label="Open Navigation Menu"
          >
            <FontAwesomeIcon icon={faBars} style={{ fontSize: '20px' }} />
          </button>
          <img src="/assets/images/logo.svg" alt="Cyfrid" height={26} width={75} className="img-fluid" />
          <div style={{ width: '20px' }} />
        </div>
      )}

      {/* Sidebar: Desktop sticky, Mobile offcanvas drawer */}
      <div className="flex-shrink-0 position-relative" style={{ zIndex: 1030 }}>
        <Sidebar />
      </div>

      <main className="main-container container-fluid flex-grow-1 overflow-auto" style={{ height: '100vh' }}>
        <Suspense fallback={<Loading />}>
          <Outlet />
        </Suspense>
      </main>
    </div>
  )
}
export default PrivateLayout